// src/shared/store/apiSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { makeApiRequest } from '../api';

export const fetchAllKb = createAsyncThunk(
  'allKb/fetchAllKb',
  async(_, { rejectWithValue }) => {
    try {
      const response = await makeApiRequest('GET', 'kb');
      return response;
    } catch (error) {
      return rejectWithValue('Error fetching dashboard config.');
    }
  }
);

// Slice
const kbSlice = createSlice({
  name: 'allKb',
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {
    clearAllKb: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllKb.pending, (state) => {
        state.loading = true;
        state.data = null;
        state.error = null;
      })
      .addCase(fetchAllKb.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllKb.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearAllKb } = kbSlice.actions;

export default kbSlice.reducer;
